import { MAINNET_RELAY_API } from '@reservoir0x/relay-sdk'
import type { RelayTokenPriceInfo } from './types'

export async function getRelayAssetPriceInfo({
  chainId,
  address,
}: {
  chainId: string
  address: string
}): Promise<RelayTokenPriceInfo> {
  const url = `${MAINNET_RELAY_API}/currencies/token/price?chainId=${chainId}&address=${address}`
  const response = await fetch(url)
  if (!response.ok) {
    throw Error(response.statusText)
  }

  const data = await response.json()
  return data as RelayTokenPriceInfo
}
